import styled from 'styled-components';

export const HeaderContainer = styled.div.attrs({})`
  background-color: ${(props) => props.theme.palette.primary.main};
  min-height: 73px;
  width: 100%;
  box-shadow: 0px 3px 6px ${(props) => props.theme.palette.colors.shadow};
`;

export const RowCenter = styled.div.attrs({})`
  display: flex;
  align-items: center;
  height: 73px;
  @media (max-width: 767px) {
    justify-content: space-between;
  }
`;

export const RowEnd = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 73px;
  gap: 0 20px;
  @media (max-width: 767px) {
    display: none;
  }
`;

export const HeaderLeftMenu = styled.ul.attrs({})`
  list-style: none;
  padding: 0;
  margin: 0;
  height: 100%;
  @media (max-width: 767px) {
    display: none;
  }
`;

export const HeaderMenuItem = styled.li.attrs({})`
  display: inline-flex;
  height: 100%;
  align-items: center;
  padding: 0 15px;
  cursor: pointer;
  color: ${(props) => props.theme.palette.colors.white};
  font-size: 15px;
  ${(props) =>
    props.active
      ? `
            background-color: ${(props) => props.theme.palette.colors.shadow};
            font-weight: bold;
        `
      : ``}
  :hover {
    opacity: 0.8;
  }
  @media (max-width: 769px) {
    padding: 0 12px;
  }
`;
